'use client';

import { FC, useEffect } from 'react';
import styles from './Support.module.scss';
import Layout from '@/src/components/layout/Layout';
import Wrapper from '@/src/components/ui/wrapper/Wrapper';
import Breadcrumbs from '@/src/components/ui/breadcrumbs/Breadcrumbs';
import { ITheme } from '@/src/lib/types/themeInterface';
import Button from '@/src/components/ui/button/Button';
import { useInView } from 'react-intersection-observer';
import createAnimationArr from '@/src/lib/helpers/createAnimationArr';
import Link from 'next/link';
import classNames from 'classnames';
import { baseUrl } from '@/src/lib/utils/baseUrl';
import SubscribeSection from '@/src/components/sections/subscribeSection/SubscribeSection';
import { PageIcon } from './icons/PageIcon';
import HelpSection from '../../sections/helpSection/HelpSection';

type TSupport = {
  themesData: Partial<ITheme>[];
};

const Support: FC<TSupport> = ({ themesData }) => {
  useEffect(() => {
    return () => {
      document.body.style.cssText = 'overflow-y: initial; position: initial; height: auto;';
    };
  }, []);

  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0,
  });

  const heading = 'Help Center';
  const excerpt = `Explore our detailed documentation and benefit from support.`;

  return (
    <Layout>
      <Breadcrumbs />
      <Wrapper className={styles.wrapper}>
        <header ref={ref} className={styles.info}>
          <h1
            className={classNames('heading__1', styles.heading, inView && styles.animate__heading)}>
            {createAnimationArr(heading, styles.word__wrapper, 0, 0.01)}
          </h1>
          <p className={classNames('excerpt', styles.excerpt, inView && styles.animate__excerpt)}>
            {createAnimationArr(excerpt, styles.word__wrapper, 0.3, 0.01)}
          </p>
        </header>

        <ul className={styles.themeСards}>
          {themesData.map((theme) => {
            const documentationURL =
              theme.documentationLink || baseUrl(`help-center/documentation/${theme.slug}`);

            return (
              <li key={theme._id} className={styles.themeCard}>
                <Link href={documentationURL} className={styles.themeCard__wrapper}>
                  <PageIcon />
                  <div className={styles.themeCard__info}>
                    <h2 className={classNames('heading__5', styles.themeCard__title)}>
                      {theme.title}
                    </h2>
                    <Button color="clear" action="interactive" ariaLabel="View Documentation">
                      View Documentation
                    </Button>
                  </div>
                </Link>
              </li>
            );
          })}
        </ul>
      </Wrapper>
      <HelpSection backgroundColor="white" />
      <SubscribeSection colorScheme="grey" />
    </Layout>
  );
};

export default Support;
